module.exports = __webpack_public_path__ + "static/media/google-store-w.acaead2b.svg";